/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9jaHJvbm9jYXNoVjMvdWFjL3dlYmFwcC1jbGsvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9hbGVydC1jb25maXJtYXRpb24vYWxlcnQtY29uZmlybWF0aW9uLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci9jaHJvbm9jYXNoVjMvdWFjL3dlYmFwcC1jbGsvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9hbGVydC1jb25maXJtYXRpb24vYWxlcnQtY29uZmlybWF0aW9uLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/components/alert-confirmation/alert-confirmation.component.scss.shim.ngstyle.ts